import { render } from "./PrepararPedidoMostradorPage.vue?vue&type=template&id=9edede14&scoped=true"
import script from "./PrepararPedidoMostradorPage.vue?vue&type=script&lang=js"
export * from "./PrepararPedidoMostradorPage.vue?vue&type=script&lang=js"

import "./PrepararPedidoMostradorPage.vue?vue&type=style&index=0&id=9edede14&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9edede14"]])

export default __exports__